import { useIsOnCartPage } from "@faire/retailer-visitor-shared/hooks/cart/useIsOnCartPage";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { QueryParameters as CartPageQueryParams } from "@faire/web-api--source/routes/cart";
import { useMemo } from "react";
export var useFilterKeys = function() {
    var isOnCartPage = useIsOnCartPage();
    var filters = useQueryParams(CartPageQueryParams.parse).filters;
    var filterKeys = useMemo(function() {
        return filters === null || filters === void 0 ? void 0 : filters.split(",");
    }, [
        filters
    ]);
    return isOnCartPage ? filterKeys : undefined;
};
